import { FloatingLabelInput, FloatingLabelSelect, FloatingLabelTextarea, FormCheckbox } from '../../components.js';
import { EditPage, populateEditForm } from '../crud/shared.js';

export class BillingEdit extends EditPage {
  static statusOptions = [
    { value: 'trialing', label: 'Trialing' },
    { value: 'active', label: 'Active' },
    { value: 'past_due', label: 'Past Due' },
    { value: 'canceled', label: 'Canceled' },
    { value: 'incomplete', label: 'Incomplete' }
  ];

  static timlComponents = {
    ...EditPage.timlComponents,
    FloatingLabelSelect,
    FormCheckbox
  };

  static get formAction() {
    return API.resourceUrl('billing', Routing.params.id);
  }

  static timl = `
    <Breadcrumbs title="Billing" href="/billing" nameHref="/billing/{{ Routing.params.id }}" nameStyle="" nameSeparatorStyle="" suffix="Edit" suffixStyle="" suffixSeparatorStyle="">

    form.fade.stacked-form[method="PATCH" action="{{ Routing.routeObject.formAction }}" onSuccessRedirect="/billing"]
      <FloatingLabelInput label="Name" name="name">
      <FloatingLabelTextarea label="Description (optional)" name="description" required="false">
      <FloatingLabelInput label="Stripe Customer ID (optional)" name="stripeCustomerId" required="false">
      <FloatingLabelInput label="Stripe Subscription ID (optional)" name="stripeSubscriptionId" required="false">
      <FloatingLabelInput label="Stripe Price ID (optional)" name="stripePriceId" required="false">
      <FloatingLabelSelect label="Status" name="status" options="{{ Routing.routeObject.statusOptions }}">
      <FloatingLabelInput label="Plan Name (optional)" name="planName" required="false">
      <FloatingLabelInput label="Current Period Start (optional)" name="currentPeriodStart" required="false">
      <FloatingLabelInput label="Current Period End (optional)" name="currentPeriodEnd" required="false">
      <FormCheckbox label="Cancel At Period End" name="cancelAtPeriodEnd">
      .horizontal-flex.mt-15
        <FormButton label="Update">
        a.underline.pointer.ml-auto.red.f12[href="/{{ Routing.getRouteFromPathName() }}/{{ Routing.params.id }}/delete"] Delete
  `;

  static javascript() {
    API.get(API.resourceUrl('billing', Routing.params.id))
      .then(data => {
        populateEditForm(data.data);
        document.querySelector('#name').innerHTML = data.data.name;
        document.querySelector('.fade:not(.in)').classList.add('in');
      });
  }
}
